const customerRepSidebarRoutes = [
  {
    route: '/dashboard',
    label: 'Dashboard'
  },
  {
    route: '/customers',
    label: 'Associated Customers'
  },
  {
    route: '/salesRep/carriers',
    label: 'Carriers'
  },
  {
    route: '/new-quote',
    label: 'New Quote'
  },
  {
    route: '/salesRep/recentQuotes',
    label: 'Recent Quotes'
  },
  {
    route: '/salesRep/pending-quotes',
    label: 'Pending'
  },
  {
    route: '/salesRep/active-shipment',
    label: 'Assigned'
  },
  {
    route: '/salesRep/enroute-quotes',
    label: 'Enroute'
  },
  {
    route: '/salesRep/completed-quotes',
    label: 'Delivered'
  }
];

export default customerRepSidebarRoutes;
